import React from 'react';
import { Input, Button } from "reactstrap";
import './style.css';

function Newsletter() {
    return (
        <div className="py-5">
            <div className="bg_newsletter">
                <div className="content_newsletter">
                    <p className="fs-2 text-center mb-2 fw-bold">Newsletter</p>
                    <p className="t-grey text-center mb-5">Sign up for our newletter to recevie updates an exlusive offers</p>

                    <div className="d-flex align-items-center line_border line-border--bg w-100">
                        <Input className="border-0 ps-4 py-2" type="email" placeholder="Enter you email..." />

                        <Button className="d-flex align-items-center ms-1 btn_search">
                            <span className="t-white ms-2 px-3 py-1">Subscribe</span>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Newsletter;